function HashSet() {
  this._arr = new Array();
}

HashSet.prototype.add = function(e) {
  var arr = this._arr;
  var i = arr.indexOf(e);
  if (i == -1) arr.push(e);
}

HashSet.prototype.get = function(i) {
  return this._arr[i];
}

HashSet.prototype.remove = function(e) {
  var arr = this._arr;
  var i = arr.indexOf(e);
  if (i != -1) arr.splice(i, 1);
}

HashSet.prototype.toString = function() {
  return this._arr.join(',');
}

HashSet.prototype.size = function() {
  return this._arr.length;
}

var processShopifyVariants = function(variantsJsonString) {
  
  if (variantsJsonString != null && variantsJsonString.length != 0) {
    
    // initial
    var featuredImage = $.evalJSON(variantsJsonString).featured_image;
    var handle = $.evalJSON(variantsJsonString).handle;
    var title = $.evalJSON(variantsJsonString).title;
    var description = $.evalJSON(variantsJsonString).description;
    var price = $.evalJSON(variantsJsonString).price;
    
    // renderring picture
    $('#quickViewDiv').append('<a id="picLink">');
    $('#picLink').append('<img src="'+featuredImage+'" alt="'+handle+'" style="width:302px;height:227px"/>');
    
    // renderring description
    $('#quickViewDiv').append('<p id="description">');
    $('#description').html(description);
    
    // renderring MORE
    $('#quickViewDiv').append('<a href="#">MORE</a>');
    
    // renderring variants
    // renderring title
    $('#quickViewDiv').append('<div id="variantsDiv">');
    $('#variantsDiv').append('<h3 id="title">');
    $('#title').append(title);
    
    // renderring price
    $('#variantsDiv').append('<span id="price" class="price">');
    $('#price').append($('.details.price').html());
    
    var variantsAry = $.evalJSON(variantsJsonString).variants;
    
    // add to HashSet
    var set1 = new HashSet();
    var set2 = new HashSet();
    var set3 = new HashSet();
    var set4 = new HashSet();
    for (var i = 0; i < variantsAry.length; i++) {
      var temp = JSON.stringify(variantsAry[i]);
      
      var opt1 = $.evalJSON(temp).option1;
      var opt2 = $.evalJSON(temp).option2;
      var opt3 = $.evalJSON(temp).option3;
      
      if (opt1 != null && opt1.length != 0 && opt1 != undefined) set1.add(opt1);
      if (opt2 != null && opt2.length != 0 && opt2 != undefined) set2.add(opt2);
      if (opt3 != null && opt3.length != 0 && opt3 != undefined) set3.add(opt3);
      
      var title = $.evalJSON(temp).title;
      var variantId = $.evalJSON(temp).id;
      set4.add(title+':'+variantId);
    }
    
    // renderring select
    if (set1 != null && set1.size() != 0 && set1 != undefined) {
      $('#quickViewDiv').append('<select id="option1">');
      for (var i = 0; i < set1.size(); i++) {
        var tmp = set1.get(i);
        $('#option1').append('<option value="'+tmp+'">'+tmp+'</option>');
      }
    }
    
    if (set2 != null && set2.size() != 0 && set2 != undefined) {
      $('#quickViewDiv').append('<select id="option2">');
      for (var i = 0; i < set2.size(); i++) {
        var tmp = set2.get(i);
        $('#option2').append('<option value="'+tmp+'">'+tmp+'</option>');
      }
    }
    
    if (set3 != null && set3.size() != 0 && set3 != undefined) {
      $('#quickViewDiv').append('<select id="option3">');
      for (var i = 0; i < set3.size(); i++) {
        var tmp = set3.get(i);
        $('#option3').append('<option value="'+tmp+'">'+tmp+'</option>');
      }
    }
    
    // renderring invisible name value paris
    $('#quickViewDiv').append('<select id="pairs">');
    for (var i = 0; i < set4.size(); i++) {
      var tmp = set4.get(i);
      var t = tmp.split(':');
      $('#pairs').append('<option value="'+t[1]+'">'+t[0]+'</option>');
    }
    
    // renderring quantity text
    $('#quickViewDiv').append('<input type="text" id="quantity" value="1">');
    
    // renderring add-to-cart button
    $('#quickViewDiv').append('<button id="addToCart" onclick="addToCart(\''+handle+'\')">Add To Cart</button>');
    return $('#quickViewDiv').html();
  }
};

var renderVariants = function(handle) {
  var url = '/products/'+handle+'.js?fields=handle,options,variants';
  
  $.ajax({
    url: url,
    type: 'get',
    dataType: 'json',
    success: function(data) {
      var jsonString = JSON.stringify(data);
      
      $.ajax({
        url: 'http://demo-maxtian.myshopify.com/collections/feed/products/koala',
        type: 'GET',
        dataType: 'html',
        success: function(data) {
          $('#quickViewDiv').html(data);
          
          var s = $('#summary').html();
          
          $.fancybox({
          	'maxWidth'  : 920,
            'maxHeight' : 600,
            'fitToView' : false,
            'width'   : '70%',
            'height'    : '70%',
        	'autoSize'  : false,
        	'closeClick'  : false,
        	'openEffect'  : 'none',
        	'closeEffect' : 'none',
            'content': data
          });
        }
      });
      
      
      //$.fancybox({'onCleanup': $('#quickViewDiv').html('')});
      //processShopifyVariants(jsonString);
    }
  });
};

var addToCart = function(handle) {
  
  var option1 = $('#option1').val();
  var option2 = $('#option2').val();
  var option3 = $('#option3').val();
  
  var selectedText = "";
  
  if (option1 != undefined) {
    selectedText += option1 + ' / ';
    
    if (option2 != undefined) {
      selectedText += option2 + ' / ';
      
      if (option3 != undefined) {
        selectedText += option3;
      }
    }
  }
  
  selectedText = selectedText.substring(0, selectedText.length - 3);
  
  $('#pairs option').each(function() {
    
    if($(this).text() == selectedText) {
      $(this).prop("selected", true);
    }
  });
  
  var variantId = $('#pairs').val();
  var qt = $('#quantity').val();
  
  $.ajax({
    url: '/cart/add.js?id='+variantId+'&quantity='+qt,
    type: 'POST',
    dataType: 'json',
    success: function(data) {
      $.fancybox.close();
      
      var quickViewId = '#'+handle;
      $(quickViewId).fadeIn(2500, function(){
        $(quickViewId).html('Added!');
        
      });
      setTimeout(function(){
        $(quickViewId).html('Quick View');
      }, 2500);
    }
  });
};



